import { render, staticRenderFns } from "./pdfContract.vue?vue&type=template&id=4875d3c0&scoped=true"
import script from "./pdfContract.vue?vue&type=script&lang=js"
export * from "./pdfContract.vue?vue&type=script&lang=js"
import style0 from "./pdfContract.vue?vue&type=style&index=0&id=4875d3c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875d3c0",
  null
  
)

export default component.exports